<template>
  <div class="navbar">
    <div class="navbar-left">
      <i
        :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
        class="collapse-btn"
        @click="toggle"
      ></i>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item
          v-for="(item, index) in breadcrumbs"
          :key="index"
          :to="item.path ? { path: item.path } : ''"
        >{{ item.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="navbar-right">
      <el-dropdown trigger="click" @command="handleCommand">
        <span class="user-info">
          <el-avatar :size="32" :src="adminInfo && adminInfo.avatar">{{ nickname }}</el-avatar>
          <span class="nickname">{{ nickname || '管理员' }}</span>
          <i class="el-icon-arrow-down"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="profile">个人信息</el-dropdown-item>
          <el-dropdown-item divided command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Navbar',
  emits: ['toggle'],
  computed: {
    ...mapGetters(['adminInfo', 'nickname']),
    isCollapse () {
      return this.$parent && this.$parent.collapse
    },
    breadcrumbs () {
      const matched = this.$route.matched.filter(r => r.meta && r.meta.title)
      return matched.map(r => ({ path: r.path === '/' ? '' : r.path, title: r.meta.title }))
    }
  },
  methods: {
    toggle () {
      this.$emit('toggle', !this.isCollapse)
    },
    async handleCommand (cmd) {
      if (cmd === 'logout') {
        try {
          await this.$confirm('确认退出登录？', '提示', { type: 'warning' })
          this.$store.dispatch('logout')
          this.$router.push('/login')
        } catch (e) { /* 取消 */ }
      } else if (cmd === 'profile') {
        this.$message.info('个人信息页面开发中')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}
.navbar-left {
  display: flex;
  align-items: center;
}
.collapse-btn {
  font-size: 20px;
  cursor: pointer;
  margin-right: 12px;
  padding: 0 6px;
}
.collapse-btn:hover {
  color: #409EFF;
}
.navbar-right .user-info {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.navbar-right .nickname {
  margin: 0 8px;
}
</style>
